import { TextField as MUI_TextField, Typography } from '@mui/material';
import styles from './textField.module.scss';
import clsx from 'clsx';
import { useId } from 'react';

const TextField = ({ className, label, error, InputProps, ...rest }) => {
    const id = useId();

    return (
        <div>
            {label && (
                <Typography htmlFor={id} component="label" className={styles.label}>
                    {label}
                </Typography>
            )}
            <MUI_TextField
                id={id}
                variant="standard"
                error={!!error}
                helperText={error}
                InputProps={{ disableUnderline: true, ...(InputProps || {}) }}
                className={clsx(styles.input, className)}
                {...rest}
            />
        </div>
    );
};

export default TextField;
